let cachedCanControlVolume: boolean | null = null

/**
 * iOS (and iPadOS) ignore HTMLMediaElement.volume for audible output.
 * Reading volume back still returns the written value, so UA detection is required.
 */
function isAppleTouchDevice(): boolean {
  if (typeof navigator === "undefined") return false

  const ua = navigator.userAgent
  if (/iPhone|iPod|iPad/i.test(ua)) return true

  // iPadOS 13+ reports as Macintosh with touch
  return (
    navigator.platform === "MacIntel" &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1
  )
}

/** True when HTMLMediaElement.volume changes audible output. */
export function canControlVolume(): boolean {
  if (typeof window === "undefined") return true
  if (cachedCanControlVolume !== null) return cachedCanControlVolume

  cachedCanControlVolume = !isAppleTouchDevice()
  return cachedCanControlVolume
}
